/*
 * @Description:
 * @Author: 姓名
 * @Date: 2025-03-31 17:38:12
 * @LastEditTime: 2025-04-11 11:20:26
 * @LastEditors: caoran
 */
import React, { useEffect, useState, useRef } from 'react'
import { Input, Drawer, message, Spin, List } from 'antd'
import {
  useAppDispatch,
  useAppSelector,
  useAiChatDrawer
} from '../../../app/hooks'
import './index.scss'
import { getAgentChatList, getApiHost } from '../../../actions/aiChat'
import allow_left from '../../../images/ai-chat/allow_left.png'
import send_blue from '../../../images/ai-chat/send_blue.png'
import send_grey from '../../../images/ai-chat/send_grey.png'

import MarkdownIt from 'markdown-it'
import { CopyOutlined, DislikeOutlined, LikeOutlined } from '@ant-design/icons'
const md = new MarkdownIt()
const { TextArea } = Input
const apiHost = getApiHost()
console.log('apiHost', apiHost)
// https://webapitest.xhey.top
// https://webapi.5181688.com

const contentType = {
  OPENING_REMARK: 0, // 开场语
  TEXT: 1, // 文本
  IMAGES: 2, // 用,合并的图片字符串
  VIDEO: 3 // 视频
}
interface chatListItemProps {
  role: string
  contentType: number
  content: string
  goodJob?: boolean
  notGoodJob?: boolean
  created_at?: number
  completed?: boolean
  isHistory?: boolean
}

const AiChatDrawer = () => {
  const aiChatDrawer = useAiChatDrawer()
  const aiChatDrawerStatus = useAppSelector(
    (state: any) => state.main.aiChatDrawerStatus
  )
  const dispatch = useAppDispatch()
  const userID = useAppSelector((state) => state.main.user?.user_id)

  // 声明常量
  const LIMIT = 10

  const {
    questionInfo,
    referenceImage,
    agentInfo,
    handleSensorEvent = () => {}
  } = aiChatDrawerStatus?.info || {}
  const [historyQuestionData, setHistoryQuestionData] = useState<string[]>([])
  const [chatData, setChatData] = useState<chatListItemProps[]>([])
  const [inputValue, setInputValue] = useState('')
  const [noScroll, setNoScroll] = useState(false)
  const [loadingMore, setLoadingMore] = useState(false)
  const [lastID, setLastID] = useState(0)
  const [hasMore, setHasMore] = useState(true)
  const [answerLoading, setAnswerLoading] = useState(false)
  const controller = useRef<any>(null)
  const currentReferenceImage = useRef<string>(referenceImage || '')
  const answering = useRef<boolean>(false)
  const chatContentRef = useRef<HTMLDivElement>(null)
  const inputRef = useRef<any>(null)

  useEffect(() => {
    currentReferenceImage.current = referenceImage
    let historyQuestions = localStorage.getItem('historyQuestionData')
    if (!historyQuestions || historyQuestions === '[]') {
      setHistoryQuestionData(agentInfo?.pre_questions || [])
    } else {
      setHistoryQuestionData(
        [...JSON.parse(historyQuestions), agentInfo?.pre_questions].slice(0, 2)
      )
    }
    if (aiChatDrawerStatus?.visible) {
      handleSensorEvent('showPop', { pageType: 2 })
      fetchChatHistory(false)
      inputRef.current &&
        setTimeout(() => {
          inputRef.current.focus()
        }, 500)
    } else {
      handleSensorEvent('closePop', { pageType: 2 })
      handleStopAnswer()
      setChatData([])
      setLastID(0)
      setHasMore(true)
      setLoadingMore(false)
    }
  }, [aiChatDrawerStatus?.visible])

  useEffect(() => {}, [chatData, answerLoading])

  // useEffect 添加滚动监听, 加载更多
  useEffect(() => {
    const container = chatContentRef.current
    const handleScroll = () => {
      if (container && !loadingMore && hasMore) {
        // 当滚动到顶部 50px 范围内时加载
        if (container.scrollTop < 50) {
          fetchChatHistory(true)
        }
      }
    }
    if (container && aiChatDrawerStatus?.visible) {
      container.addEventListener('scroll', handleScroll)
    }

    return () => {
      if (container) {
        container.removeEventListener('scroll', handleScroll)
      }
    }
  }, [loadingMore, hasMore])

  // 获取聊天历史
  const fetchChatHistory = async (loadMore) => {
    setLoadingMore(true)
    const container = chatContentRef.current
    // 记录加载前的滚动高度
    const prevScrollHeight = container?.scrollHeight || 0
    try {
      const res = await dispatch(
        getAgentChatList({
          userID: userID,
          agentID: agentInfo.agent_id,
          limit: LIMIT,
          lastID: lastID
        })
      )
      const temp = res?.data?.reverse() || []
      const list = temp.map((item, index) => {
        return {
          ...item,
          completed: true,
          isHistory: true
        }
      })
      if (!loadMore) {
        const newData = [
          ...list,
          {
            role: 'user',
            contentType: 2,
            content: currentReferenceImage.current
          },
          {
            role: 'user',
            content: questionInfo.content,
            contentType: contentType.TEXT
          }
        ]
        setChatData(newData)
        setHistoryStorage(questionInfo.content)
        getAgentAnswer(questionInfo.content, newData.length)
      } else {
        setChatData((prev) => {
          const newData = [...list, ...prev]
          // 在下一次渲染后调整滚动位置
          setTimeout(() => {
            if (container) {
              container.scrollTop = container.scrollHeight - prevScrollHeight
            }
          }, 0)
          return newData
        })
      }
      if (!list.length && loadMore) {
        message.info('没有更多数据了')
        setHasMore(false)
      } else {
        setLastID(res.lastID)
      }
    } finally {
      setLoadingMore(false)
    }
  }

  // 滚动到底部
  const scrollToBottom = () => {
    console.log('scrollToBottom')
    if (chatContentRef.current && !noScroll) {
      requestAnimationFrame(() => {
        if (chatContentRef.current) {
          chatContentRef.current.scrollTop = chatContentRef.current.scrollHeight
        }
      })
    }
  }

  // 存储历史问题
  const setHistoryStorage = (content) => {
    const historyQuestions = localStorage.getItem('historyQuestionData') || ''
    const historyQuestionsData = JSON.parse(historyQuestions) || []
    const index = historyQuestionsData.indexOf(content)
    if (index !== 0) {
      localStorage.setItem(
        'historyQuestionData',
        JSON.stringify([content, historyQuestionsData[0]])
      )
    }
  }

  // 发送消息
  const sendMessage = (value = '') => {
    const content = value.trim()
    if (!content) return
    const newData = [
      ...chatData,
      {
        role: 'user',
        content: content,
        contentType: contentType.TEXT
      }
    ]
    setChatData(newData)
    getAgentAnswer(content, newData.length)
    setInputValue('')
    setHistoryStorage(content)
  }

  // 获取通用Agent回答
  const getAgentAnswer = async (chatReq, index) => {
    answering.current = true
    controller.current = new AbortController()
    const { signal } = controller.current
    setAnswerLoading(true)
    try {
      setNoScroll(false)
      scrollToBottom()
      const params = {
        question: chatReq,
        userID,
        agentID: Number(agentInfo.agent_id),
        model: agentInfo.model,
        agent_type: agentInfo.agent_type,
        reference_image_switch: agentInfo.reference_image_switch,
        referenceImage: currentReferenceImage.current
      }
      const url = apiHost + '/web/agent/chat/completion'
      const response = await fetch(url, {
        method: 'POST', // 指定请求方法为 POST
        headers: {
          'Content-Type': 'application/json' // 设置请求头为 JSON 格式
        },
        body: JSON.stringify(params), // 将数据转换为 JSON 字符串
        signal // 中断信号
      })
      setAnswerLoading(false)
      currentReferenceImage.current = ''
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      const reader = response.body?.getReader() // 获取流式读取器
      const decoder = new TextDecoder('utf-8') // 用于解码二进制数据
      while (answering.current) {
        const chunkInfo = await reader?.read() // 读取一个数据块
        const { done, value } = chunkInfo || {}
        if (done) {
          answering.current = false
          setChatData((prevChatData) => {
            console.log('prevChatData', prevChatData)
            handleSensorEvent('conversation', {
              pageType: 2,
              string1: chatReq,
              string2: prevChatData[index].content
            })
            return prevChatData.map((ele, i) => {
              if (i === index) {
                console.log('i === index')
                return {
                  ...ele,
                  completed: true
                }
              } else {
                return ele
              }
            })
          })
          break
        }

        let chunk = decoder.decode(value, { stream: true }) // 解码数据块
        console.log('chunk', chunk)
        updateMessageContent(chunk, index)
        scrollToBottom()
      }
    } catch (error) {
      console.log('error', error)
      setAnswerLoading(false)
      answering.current = false
    }
  }

  // 更新消息内容
  const updateMessageContent = (chunk, index) => {
    setChatData((prevChatData) => {
      if (index === prevChatData.length) {
        return [
          ...prevChatData,
          {
            role: 'assistant',
            content: chunk,
            contentType: contentType.TEXT,
            completed: false,
            goodJob: false,
            notGoodJob: false
          }
        ]
      } else {
        return prevChatData.map((ele, i) => {
          if (i === index) {
            return {
              ...ele,
              content: ele.content + chunk
            }
          } else {
            return ele
          }
        })
      }
    })
  }

  // 停止回答
  const handleStopAnswer = () => {
    answering.current = false
    if (controller.current) {
      controller.current.abort() // 中断请求
      controller.current = null // 清空 controller，避免复用
    }
  }

  // 点赞 // 点踩
  const handleGoodIconClick = (type, index) => {
    handleSensorEvent(type === 'goodJob' ? 'clickGood' : 'clickBad', {
      pageType: 2
    })
    setChatData((prev) =>
      prev.map((ele, i) => {
        if (i === index) {
          return {
            ...ele,
            notGoodJob: type === 'notGoodJob' ? !ele.notGoodJob : false,
            goodJob: type === 'goodJob' ? !ele.goodJob : false
          }
        } else {
          return ele
        }
      })
    )
  }

  // 复制
  const clipboardAction = async (item, index) => {
    try {
      handleSensorEvent('clickCopy', { pageType: 2 })
      const text = chatData[index].content
      // 去除markdown语法，只保留文本内容
      const plainText = text
        .replace(/(#+\s*)/g, '') // 标题
        .replace(/(\*\*|__)(.*?)\1/g, '$2') // 加粗
        .replace(/(\*|_)(.*?)\1/g, '$2') // 斜体
        .replace(/!\[(.*?)\]\(.*?\)/g, '$1') // 图片
        .replace(/\[(.*?)\]\(.*?\)/g, '$1') // 链接
        .replace(/`{3}.*\n?/g, '') // 代码块
        .replace(/`/g, '') // 行内代码
      await navigator.clipboard.writeText(plainText)
      message.success('复制成功', 1.5)
    } catch (err) {
      message.error('复制失败，请手动选择文本复制')
    }
  }

  if (aiChatDrawerStatus?.visible) {
    return (
      <>
        <Drawer
          title="AI 识图提问"
          className="ai-chat-drawer"
          placement="right"
          size={480}
          onClose={() => {
            aiChatDrawer.close()
          }}
          open={aiChatDrawerStatus.visible}
          getContainer={false}
          style={{ position: 'absolute' }}
        >
          <div className="chat-content" ref={chatContentRef}>
            {loadingMore && (
              <div style={{ textAlign: 'center', padding: '10px' }}>
                <Spin tip="加载中..." />
              </div>
            )}
            <List
              dataSource={chatData}
              renderItem={(item, index) => {
                if (item.role === 'user') {
                  return (
                    <div className="content-wrapper" key={index}>
                      <div className="user-content">
                        {item.contentType === contentType.TEXT && (
                          <div className="text">{item.content}</div>
                        )}
                        {item.contentType === contentType.IMAGES && (
                          <img className="image" src={item.content} alt="" />
                        )}
                      </div>
                    </div>
                  )
                } else {
                  return (
                    <div key={index} className="assistant-content">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: md.render(item.content)
                        }}
                      />
                      {item.completed && (
                        <div className="operate-button-wrapper">
                          <div onClick={() => clipboardAction(item, index)}>
                            <CopyOutlined className="operate-icon" />
                          </div>

                          <div className="divider-line"></div>
                          <div
                            onClick={() =>
                              handleGoodIconClick('goodJob', index)
                            }
                          >
                            <LikeOutlined
                              className={
                                item.goodJob
                                  ? 'operate-icon-check'
                                  : 'operate-icon'
                              }
                            />
                          </div>
                          <div
                            onClick={() =>
                              handleGoodIconClick('notGoodJob', index)
                            }
                          >
                            <DislikeOutlined
                              className={
                                item.notGoodJob
                                  ? 'operate-icon-check'
                                  : 'operate-icon'
                              }
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  )
                }
              }}
            />
            {answerLoading && <Spin />}
          </div>

          <div className="input-box">
            {historyQuestionData?.length && (
              <div className="question-box">
                {historyQuestionData.map((ele: any, index: number) => (
                  <div className="question-wrapper" key={index}>
                    <div
                      className="question"
                      onClick={() => {
                        handleSensorEvent('clickContent', {
                          pageType: 2,
                          string1: ele
                        })
                        sendMessage(ele)
                      }}
                      key={index}
                    >
                      {ele}
                    </div>
                    <img src={allow_left} alt="" />
                  </div>
                ))}
              </div>
            )}
            <TextArea
              rows={4}
              ref={inputRef}
              placeholder="请输入您的问题"
              maxLength={500}
              className="input"
              value={inputValue}
              onChange={(e) => {
                const value = e.target.value
                setInputValue(value)
              }}
            />
            <img
              className="send-icon"
              src={
                inputValue.length > 0 && !answering.current
                  ? send_blue
                  : send_grey
              }
              alt=""
              style={{ cursor: 'pointer', height: '28px', width: '28px' }}
              onClick={() => {
                if (answering.current) return
                handleSensorEvent('clickSend', {
                  pageType: 2,
                  string1: inputValue
                })
                sendMessage(inputValue)
              }}
            />
            <div className="declare">内容由AI模型生成，请注意甄别</div>
          </div>
        </Drawer>
      </>
    )
  } else {
    return null
  }
}

export default AiChatDrawer
